import categories from 'api/categories'
import * as types from '../mutation-types'

const Promise = window.Promise || require('promise')

export const fetchCompanyCategories = ({ commit }) => {
  return categories.get('company').then((data) => {
    commit(types.COMPANY_CATEGORIES, data.results)
    return Promise.resolve(data.results)
  }, (err) => {
    return Promise.reject(err)
  })
}

export const fetchVacancyCategories = ({ commit }) => {
  return categories.get('vacancy').then((data) => {
    commit(types.VACANCY_CATEGORIES, data.results)
    return Promise.resolve(data.results)
  }, (err) => {
    return Promise.reject(err)
  })
}

export const initializeVacancyCategory = ({ commit }, data) => {
  commit(types.INITIALIZE_VACANCY_CATEGORY, data)
}

export const initializeCompanyCategory = ({ commit }, data) => {
  commit(types.INITIALIZE_COMPANY_CATEGORY, data)
}

export const toggleVacancyCategory = ({ commit }, {
  parentId,
  categoryId,
  status
}) => {
  commit(types.TOGGLE_VACANCY_CATEGORY, {
    parentId: parentId,
    categoryId: categoryId,
    status: status
  })
}

export const toggleCompanyCategory = ({ commit }, {
  parentId,
  categoryId,
  status
}) => {
  commit(types.TOGGLE_COMPANY_CATEGORY, {
    parentId: parentId,
    categoryId: categoryId,
    status: status
  })
}

export const resetVacancyCategory = ({ commit }) => {
  commit(types.RESET_VACANCY_CATEGORY)
}

export const resetCompanyCategory = ({ commit }) => {
  commit(types.RESET_COMPANY_CATEGORY)
}



// WEBPACK FOOTER //
// ./src/vuex/categories/actions.js